import { Box, Stack, Typography } from '@mui/material';

import { Icon } from '@karehero/llama/components/atoms/Icon/Icon';
import { radius } from '@karehero/llama/theme/radius';

/**
 * A form's outcome, where its results are shown: a solid fill with no border and
 * no chevron, because information sits on colour and only what can be tapped
 * is a bordered card. Only for an outcome: lime for a yes, the colour for
 * "this could be theirs" and for Done; a warm neutral for a no, since it isn't
 * a success.
 */
const ResultBanner = ({
  tone,
  icon,
  name,
  description,
}: {
  tone: 'lime' | 'neutral';
  icon: string;
  name: string;
  description: string;
}) => (
  <Stack
    direction='row'
    spacing={2}
    sx={{
      p: 2,
      alignItems: 'center',
      borderRadius: `${radius.md}px`,
      bgcolor: tone === 'lime' ? 'custom.limeGreen.200' : 'custom.neutral.100',
    }}
  >
    <Box
      sx={{
        width: 40,
        height: 40,
        flexShrink: 0,
        borderRadius: '50%',
        bgcolor: 'background.paper',
        color: 'primary.main',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Icon icon={icon as never} fontSize={18} />
    </Box>
    <Stack spacing={0.5} sx={{ minWidth: 0 }}>
      <Typography variant='h6' sx={{ fontSize: '1.125rem', lineHeight: 1.4 }}>
        {name}
      </Typography>
      <Typography variant='body1'>{description}</Typography>
    </Stack>
  </Stack>
);

export default ResultBanner;
